import React from 'react';
import Head from 'next/head';
import './components.css'; // Tell webpack this Button.js uses these styles
import {  
    Button, 
    ButtonContent,
    ButtonGroup,
    Modal, 
    Header, 
    Image, 
    Container,
    ListList,
    ListItem,
    ListIcon,
    Icon,
    ListHeader,
    ListDescription,
    ListContent,
    List,
} from 'semantic-ui-react';


export default (props) => {
   return(
        <Container style={{
            // borderRadius: 10,
            justifyContent: 'center',
            alignItems: 'center',
            width: '13vw',
            height: '100vh',
            margin: 0,
            // borderStyle: 'none',
            borderWidth: 0,
            // borderColor: 'rgba(99, 191, 249, 1)',
            // border: 'none',   
        }}>
            <img className="logoImage" src="https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png"></img>
            


            <List>
            <ListItem
                style={{
                marginBottom: 10,
                marginLeft: 25
                }}
            >
                <button 
                style={{
                    marginBottom: 10,
                    borderRadius: 20,
                    backgroundColor: 'rgba(0, 158, 129, 0)',
                    borderWidth: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 15,
                }}
                className="ui huge teal button"
                
                >
                <i className="home icon"></i>
                Home
                </button>
            </ListItem>
            <ListItem
                style={{
                marginBottom: 10,
                marginLeft: 25
                }}
            >
                <button 
                onClick={() => {
                    this.setState({
                    navigationDestinationObject: {
                        navigationRoute: '/Dashboard',
                    },
                    })
                }}
                style={{
                    marginBottom: 10,
                    borderRadius: 20,
                    backgroundColor: 'rgba(0, 158, 129, 0)',
                    borderWidth: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 15,
                }}
                className="ui huge teal button"
                
                >
                <i className="search icon"></i>
                Browse
                </button>
            </ListItem>
            <ListItem
                style={{
                marginBottom: 10,
                marginLeft: 25
                }}
            >
                <button 
                onClick={() => {
                    this.setState({
                    navigationDestinationObject: {
                        navigationRoute: '/UserReceipts',
                    },
                    })
                }}
                style={{
                    marginBottom: 10,
                    borderRadius: 20,
                    backgroundColor: 'rgba(0, 158, 129, 0)',
                    borderWidth: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 15,
                }}
                className="ui huge teal button"
                >
                <i className="wait icon"></i>
                Transactions
                </button>
            </ListItem>
            <ListItem
                style={{
                marginBottom: 10,
                marginLeft: 25
                }}
            >
                <button 
                style={{
                    marginBottom: 10,
                    borderRadius: 20,
                    backgroundColor: 'rgba(0, 158, 129, 0)',
                    borderWidth: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 15,
                }}
                onClick={() => {
                    this.setState({
                    navigationDestinationObject: {
                        navigationRoute: '/NewContractICR',
                    },
                    })
                }}
                className="ui huge teal button"
                    
                >
                <i className="newspaper icon"></i>
                New Credit Line
                </button>
            </ListItem>
            <ListItem
                style={{
                marginBottom: 10,
                marginLeft: 25
                }}
            >
                <button 
                onClick={() => {
                    this.setState({
                    inviteOverlay: true
                    })
                }}
                style={{
                    marginBottom: 10,
                    borderRadius: 20,
                    backgroundColor: 'rgba(0, 158, 129, 0)',
                    borderWidth: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 15,
                }}
                className="ui huge teal button"
                
                >
                <i className="user plus icon"></i>
                Invite
                </button>
            </ListItem>
            <ListItem
                style={{
                marginBottom: 10,
                marginLeft: 25
                }}
            >
                <button 
                style={{
                    marginBottom: 10,
                    borderRadius: 20,
                    backgroundColor: 'rgba(0, 158, 129, 0)',
                    borderWidth: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 15,
                }}
                
                className="ui huge teal button"
                >
                <i className="law icon"></i>
                Terms of Use
                </button>
            </ListItem>
            <ListItem
                style={{
                marginBottom: 10,
                marginLeft: 25
                }}
            >
                <button 
                style={{
                    marginBottom: 10,
                    borderRadius: 20,
                    backgroundColor: 'rgba(0, 158, 129, 0)',
                    borderWidth: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 15,
                }}
                
                className="ui huge teal button"
                >
                <i className="star icon"></i>
                {'Blender Pro'}
                </button>
            </ListItem>
            </List>


            <button 
            
            style={{
                position: 'fixed',
                bottom: 20,
                marginBottom: 10,
                marginLeft: 25,
                borderRadius: 20,
                backgroundColor: 'rgba(0, 158, 129, 0)',
                borderWidth: 2,
                justifyContent: 'center',
                alignItems: 'center',
                padding: 15,
            }}
            className="ui medium teal button"
            >
            <i className="sign out icon"></i>
            Sign Out
            </button>
        </Container>
   ); 
};